import {styled} from '@esgi/ui/theme';
import {Text} from '@esgi/ui/typography';

export const ScoreResultText = styled(Text, {
	paddingTop: 4,
});
